import React, {
  useRef,
  forwardRef,
  useImperativeHandle,
  useEffect,
} from "react";
import SignatureCanvas from "react-signature-canvas";
import { DefaultButton, Stack } from "@fluentui/react";
import './../assets/styles/app.css';
import './../assets/styles/site-entry.css';
import { personalInformation } from "../messages/personal-Information";
const { Labels: Lbl_Personal_Info } = personalInformation;

export interface SignaturePadRef {
  clear: () => void;
  getSignature: () => string | null;
}

interface SignaturePadProps {
  height?: number;
  onChange?: (dataUrl: string | null) => void;
}

const SignaturePad = forwardRef<SignaturePadRef, SignaturePadProps>(
  ({ height = 150, onChange }, ref) => {
    const containerRef = useRef<HTMLDivElement | null>(null);
    const sigPadRef = useRef<SignatureCanvas | null>(null);
    const [canvasWidth, setCanvasWidth] = React.useState(400);

    const clear = () => {
      sigPadRef.current?.clear();
      if (onChange) onChange(null);
    };

    const getSignature = () => {
      if (sigPadRef.current && !sigPadRef.current.isEmpty()) {
        try {
          return sigPadRef.current
            .getTrimmedCanvas()
            .toDataURL("image/png");
        } catch (e) {
          return sigPadRef.current.getCanvas().toDataURL("image/png");
        }
      }
      return null;
    };

    useEffect(() => {
      if (!containerRef.current) return;
      const resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          setCanvasWidth(entry.contentRect.width);
        }
      });
      resizeObserver.observe(containerRef.current);
      return () => resizeObserver.disconnect();
    }, []);

    useImperativeHandle(ref, () => ({
      clear,
      getSignature,
    }));

    return (
      <div ref={containerRef} style={{ width: "100%" }}>
        <Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
          <SignatureCanvas
            ref={sigPadRef}
            penColor="black"
            onEnd={() => {
              if (onChange) {
                onChange(getSignature());
              }
            }}
            canvasProps={{
              width: canvasWidth,
              height: height,
              className: "customCanvas",
            }}
          />
          <DefaultButton
            text={Lbl_Personal_Info.CLEAR_BTN}
            onClick={clear}
            className="customButton"
          />
        </Stack>
      </div>
    );
  }
);

export default SignaturePad;